
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/klub/[id]",
      function () {
        return require("private-next-pages/klub/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/klub/[id]"])
      });
    }
  